<template>
  <div>
    <div class="inner">
      <div class="header">
        <div class="block-title">
          <h1>Marketplace</h1>
          <p>
            Utilizza i punti guadagnati
            per meravigliosi premi e
            offerte speciali
          </p>
        </div>
        <img
          class="points"
          src="../../assets/points.png"
          @click="$router.push({
            name:'Punti'})"
        />
      </div>
    </div>
    <img class="bg-right" src="../../assets/headerbghome.png" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HeaderHome"
};
</script>


<style lang="less" scoped>
.bg-right {
  width: 50%;
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>